import {
  get,
  post,
  patch,
  del,
} from '@/utils/request';

const url = 'videos';

// 获取视频列表
export function index(data) {
  return get({
    url,
    data,
  });
}

export function checkTranscode(raw_src) {
  return get({
    url: `${url}/transcode`,
    data: { raw_src },
  });
}

export function getStudentIdByPhone({ phone, exclude_student_id }) {
  return get({
    url: `${url}/phones/${phone}`,
    data: { exclude_student_id },
  });
}

export function getStudentIdByCardNumber({ card_number, exclude_student_id }) {
  return get({
    url: `${url}/card-numbers/${card_number}`,
    data: { exclude_student_id },
  });
}

export function getCardNumberByStudentId(id) {
  return get({
    url: `${url}/${id}/card-numbers`,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

// 注册学员
export function store(data) {
  return post({
    url,
    data,
  });
}

// 还原已注销的学员
export function restore(id) {
  return post({
    url: `${url}/${id}`,
  });
}

// 设为新老师
export function setTeacher(id) {
  return post({
    url: `${url}/${id}/teachers`,
  });
}

export function update(id, data) {
  return patch({
    url: `${url}/${id}`,
    data,
  });
}

// 绑定旧老师
export function bindTeacher(id, data) {
  return patch({
    url: `${url}/${id}/teachers`,
    data,
  });
}

export function destroy(id) {
  return del({
    url: `${url}/${id}`,
  });
}

// 取消老师绑定
export function delTeacher(id) {
  return del({
    url: `${url}/${id}/teachers`,
  });
}
